
/**
 * Custom component for CHI Chinese New Year items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.3.0
 * @copyright  Copyright (C) 2023-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 * 2026-02-17 (1.3.0) (jhoward)
 *   - Add new App\Library\Js\Components\Menu\Item\Chi_chineseNewYearItem.vue component for rendering Chinese New Year menu items in Chi.
 *   - Implements custom layout, props, and scoped styles for the new item type.
 */

import {defineComponent, PropType} from "vue";
import {MENU_ITEM_LAYOUT, MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'chi-chinese-new-year-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<MENU_ITEM_LAYOUT>,
      default: ''
    }
  },
})
